import 'modern-normalize';

import { PropsWithChildren } from 'react';

import AnalyticsProvider from '../providers/AnalyticsProvider/AnalyticsProvider';
import ApplicationProvider from '../providers/ApplicationProvider/ApplicationProvider';
import AuthFirewallProvider from '../providers/AuthFirewallProvider/AuthFirewallProvider';
import AuthProvider from '../providers/AuthProvider/AuthProvider';
import ErrorProvider from '../providers/ErrorProvider/ErrorProvider';
import ThemeProvider from '../providers/ThemeProvider/ThemeProvider';
import Router from './router';

/* -------------------------------- Providers ------------------------------- */

export const Providers = ({ children }: PropsWithChildren) => (
    <ApplicationProvider>
        <ThemeProvider>
            <AuthProvider>
                <AnalyticsProvider>{children}</AnalyticsProvider>
            </AuthProvider>
        </ThemeProvider>
    </ApplicationProvider>
);

/* ----------------------------------- App ---------------------------------- */

const App = () => (
    <AuthFirewallProvider>
        <ErrorProvider>
            <Providers>
                <Router />
            </Providers>
        </ErrorProvider>
    </AuthFirewallProvider>
);

/* --------------------------------- Export --------------------------------- */

export default App;
